import Cookies from "js-cookie"
import { uniqueId } from "lodash"

export const cookiePrefill = (cookie) => {
  return Cookies.get(cookie) ? Cookies.get(cookie) : ""
}

export function extractUniversityInfo(fields) {
  // Find the field with the name "university"
  let uniField = fields.find((field) => field.name === "university")

  let universityName = null
  let universityId = null

  if (uniField && uniField.value) {
    let uniValue = uniField.value
    let nameStartIndex = uniValue.indexOf("name:") + "name:".length

    if (nameStartIndex !== -1) {
      let nameEndIndex = uniValue.indexOf(", id:")
      if (nameEndIndex !== -1) {
        universityName = uniValue.substring(nameStartIndex, nameEndIndex).trim()
        let idStartIndex = uniValue.indexOf("id:") + "id:".length
        if (idStartIndex !== -1) {
          universityId = uniValue.substring(idStartIndex).trim()
        }
      } else {
        universityName = uniValue.substring(nameStartIndex).trim()
      }
    }
  }

  return { universityName, universityId }
}

export function extractSchoolInfo(fields) {
  // Find the field with the name "school"
  let schoolField = fields.find((field) => field.name === "school")

  let schoolName = null
  let schoolId = null

  if (schoolField && schoolField.value) {
    let schoolValue = schoolField.value
    let nameStartIndex = schoolValue.indexOf("name:") + "name:".length

    if (nameStartIndex !== -1) {
      let nameEndIndex = schoolValue.indexOf(", id:")
      if (nameEndIndex !== -1) {
        schoolName = schoolValue.substring(nameStartIndex, nameEndIndex).trim()
        let idStartIndex = schoolValue.indexOf("id:") + "id:".length
        if (idStartIndex !== -1) {
          schoolId = schoolValue.substring(idStartIndex).trim()
        }
      } else {
        schoolName = schoolValue.substring(nameStartIndex).trim()
      }
    }
  }

  return { schoolName, schoolId }
}

export const initialFields = (
  fields,
  privacyConfig,
  termsConfig,
  campaignID,
  campaignIDLabel,
  multi_campaign
) => {
  let fe = [...fields]
  // Add privacy policy field to form
  const privacyId = uniqueId()

  const label = privacyConfig?.content
    ? JSON.stringify(privacyConfig?.content[0])
    : undefined

  const privacy = {
    id: privacyId,
    _uid: privacyId,
    label: label,
    required: true,
    type: "checkbox",
    name: "privacy",
    value: false,
    valid: null,
    richText: label ? true : false,
  }

  fe.push(privacy)

  if (termsConfig) {
    const termsId = uniqueId()

    const termsLabel = termsConfig?.content
      ? JSON.stringify(termsConfig?.content[0])
      : undefined

    const terms = {
      id: termsId,
      _uid: termsId,
      label: termsLabel,
      required: true,
      type: "checkbox",
      name: "privacy",
      value: false,
      valid: null,
      richText: true,
    }

    fe.push(terms)
  }

  if (Array.isArray(campaignID) && campaignID.length >= 1) {
    const campId = uniqueId()

    const campaign = {
      id: campId,
      _uid: campId,
      required: true,
      hidden: campaignID.length > 1 ? false : true,
      label: campaignIDLabel,
      type: multi_campaign ? "multiselect" : "dropdown",
      name: "campaignID",
      value: campaignID[0].value,
      default: campaignID.length === 1 ? campaignID[0].value : undefined,
      valid: true,
      dropdown_options: campaignID,
    }

    fe.unshift(campaign)
  }

  return fe
}
